import { TUTORING_LEAD_SOURCES } from "@seneca/tutoring-service-consts";

import { OneToOneTutoringSourceParamKey } from "features/parents/routes/parent/routes/tutoring-page/links";

export function linkToAnonymousTutoringPage(source?: TUTORING_LEAD_SOURCES) {
  const queryParams = source
    ? `?${OneToOneTutoringSourceParamKey}=${source}`
    : "";

  return `/tutoring${queryParams}`;
}
